import {
    TransactionType,
    XpressDeliveryPaymentMethod,
    XpressUserWalletOperationType
} from '@shared/enums';

import {
    ExportFileTypeEnum,
    RiderVehicleTypeEnum,
    ServiceTypeEnum,
    XpressDeliveryStatus
} from 'app/models';
import { BaseListRequestModel, BaseListResponseModel, BaseResponseModel } from './base-request.model';

import { ChatMessageType } from './chat-message-type.enum';


export interface XpressDeliveryOrderByGeoZoneDto extends BaseListRequestModel {
	GeoZoneId?: number | null;
	BookingTabMenu?: BookingTabMenuEnum;
	StartDate?: Date | null;
	EndDate?: Date | null;
	ServiceTypes?: ServiceTypeEnum[];
	FileType?: ExportFileTypeEnum;
	VehicleTypes?: RiderVehicleTypeEnum[];
}

export interface XpressDeliveryOrder {
	Id: number;
	CreatedAt: Date;
	ScheduledAt?: Date;
	VehicleTypeId: RiderVehicleTypeEnum;
	VehicleTypeText: string;
	ServiceTypeId?: ServiceTypeEnum;
	ServiceTypeText: string;
	XpressRiderId?: number;
	FullNameRider: string;
	XpressUserId: number;
	FullNameUser: string;
	Amount: number;
	DriverEarnings: number;
	InitialTotalFareAmount: number;
	AmountText: string;
	AmountMapped?: number;
	AmountMappedText: string;
	StatusId: XpressDeliveryStatus;
	StatusText?: string;
	CancelRoleText: string;
	PickupLocation?: string;
	PickupLocationBuildingName?: string;
	CityName?: string;
	DeliveryRecipientName?: string;
	XpressPaymentTransactions?: any[];
	OrderAttemptsCount?: number;
	BookingTypeText: string;
	BookingLabel: string;
	DropOffLocation?: string;
	DropOffLocationBuildingName?: string;
	CustomerName: string;
	RiderName: string;
	RiderGroup: string;
	CancelReason: string;
	NetFare?: number;
	PaymentMethod: string;
	Date: string;
	ScheduledAtDate?: string;
	CompaniesText: string;
	SurgeFactor?: number;
	SurgeFactorMapped?: number;
	IsFraud: boolean;
	FraudScore: number;
	ServiceArea: string;
	Reason?: string;
	PaxCount?: number;
	SourceText?: string;
}

export interface XpressDeliveryOrderListDto extends BaseListResponseModel {
	Items?: XpressDeliveryOrder[];
	TotalEarnings: number;
}

// Regional Live Map Models
export interface GetRegionalLiveMapOrdersRequest {
	GeoZoneId: number;
	TimeZoneOffset: number;
	StatusIds?: XpressDeliveryStatus[];
	FilterLiveMapOrder?: FilterLiveMapOrders;
	ServiceTypes?: ServiceTypeEnum[];
	VehicleTypes?: RiderVehicleTypeEnum[];
	SearchName?: string;
}

export interface GetLiveMapActiveOrdersResponse extends BaseResponseModel {
	Orders?: LiveMapActiveOrderItem[];
	TotalCount: number;
	EfficiencyPercent: number;
}

export interface LiveMapActiveOrderItem {
	Id: number;
	CustomerFirstName: string;
	CustomerLastName: string;
	CustomerBetaFeatures: string;
	IsPriority: boolean;
	StatusId: XpressDeliveryStatus;
	ServiceTypeId: ServiceTypeEnum;
	ServiceType: string;
	VehicleTypeId: RiderVehicleTypeEnum;
	VehicleType: string;
	PickupAddress?: any;
	Amount: number;
	BaseFare: number;
	WaitingFeeAmount: number;
	PickupSurgeAmount: number;
	PlaceOrderAttempt: number;
	Payment: string;
	DistanceFare: number;
	SurgeCharges: number;
	TripDurationCharge: number;
	TipAmount: number;
	PromoName: string;
	PromoAmount: number;
	PromoCode: string;
	CardType: string;
	PayServiceText: string;
	ScheduledAt?: Date;
	IsScanAndRide: boolean;
	SpecialDiscountType: number;
	SpecialDiscountTypeText: string;
	SpecialDiscountAmount: number;
}

export enum FilterLiveMapOrders {
	All = 0,
	Regular = 1,
	Scheduled = 2
}

export interface GetDeliveryOrderDetailRequestDto {
	XpressDeliveryOrderId: number;
	TimeZoneOffset: number;
}
export interface XpressDeliveryOrderDetail extends BaseResponseModel {
	XpressDeliveryOrderId: number;
	UserId: number;
	MerchantName: string;
	MerchantImageUrl: string;
	MerchantRating: number;
	IsMerchantEstimated: boolean;
	LokalOrderId: number;
	BookingType: number;
	UserName: string;
	FullUserName: string;
	UserPhone: string;
	UserImageUrl: string;
	UserRating: number;
	UserGender: string;
	UserEmail: string;
	RiderName: string;
	RiderId?: number;
	RiderPhone: string;
	RiderImageUrl: string;
	RiderRating: number;
	RiderGender: string;
	RiderEmail: string;
	LTFRBCaseNumber?: string;
	OrderDateTime: Date;
	ArrivedToPickupAt?: Date;
	AcceptedAt?: Date;
	ServiceTypeId: number;
	VehicleTypeId: number;
	IsScanAndRide: boolean;
	IsShuttle: boolean;
	VehicleTypeText: string;
	Destination: string;
	Duration: string;
	CompletedTime: string;
	CompletedDateTime?: Date;
	StatusId: XpressDeliveryStatus;
	StatusText: string;
	GoogleTripId: string;
	WaitingTimeInSec: number;
	RiderMark: number;
	IsPreferredRider: boolean;
	IsUserEstimated: boolean;
	Toll: number;
	RiderInsurance: number;
	TripDurationCharge: number;
	Tips: number;
	DistanceInM: number;
	ScheduleTimeText: string;
	NetEarnings: number;
	XpressCommission: number;
	BookingFeeAmount: number;
	TotalNetEarnings: number;
	RiderBaseFare: number;
	Adjustments: number;
	OrderAttempts?: any[];
	MinAmount: number;
	MaxAmount: number;
	WaitingTime: number;
	WithholdingTaxAmount: number;
	IsFastest: boolean;
	CancelReason: string;
	CompleteReason?: string;
	CancelRoleId?: number;
	CancelRoleText: string;
	CancellationFeeAmount: number;
	Notes: string;
	IsOfflineFlow: boolean;
	SinglePaxCount?: number;
	LuggageCount?: number;
	ScheduledAt?: Date;
	PaOrCpcCaseNumber?: string;
	SpecialDiscountType: number;
	SpecialDiscountTypeText: string;
	SpecialDiscountAmount: number;
	PayService: number;
	MeteredFare: number;
	XpressFee: number;
	BaseFare: number;
	SurgeCharges: number;
	RiderXpressFee: number;
	SubtotalAmount: number;
	LguFareAmount: number;
	FlagfallAmount: number;
	Promo: number;
	PromoName: string;
	Total: number;
	PaymentMethodId: number;
	PaymentCardId?: number;
	PaymentMethodText: string;
	PaymentCardTypeId: number;
	IsRiderEstimated: boolean;
	AbleToUpdateDriverRate: boolean;
	Points?: PointWithAddress[];
	PointPickUp: string;
	PointPickUpName: string;
	PointPickUpBuildingName: string;
	PointDropOffBuildingName: string;
	PointDestination: string;
	PointDropoff?: string[];
	PointNum: number;
	OrderChannelName: string;
	VehicleFrontImageUrl: string;
	VehicleModel: string;
	VehicleModelSeries: string;
	NumberPlate: string;
	VehicleColor: string;
	VehicleColorType: number;
	RiderInstructions: string;
	DeliveryRecipientName: string;
	DeliveryRecipientPhone: string;
	DeliveryRecipientImageUrl: string;
	DeliveryWeight: number;
	DeliveryItemTypeId: number;
	DeliveryItemTypeText: string;
	ChatId: number;
	OrderSummaryList: OrderSummaryItem[];
	OrderSummaryTotalPrice?: number;
	RiderFirstName: string;
	RiderLastName: string;
	ServiceTypeText: string;
	OrderAccepted?: Date;
	PickupTime?: Date;
	DroppedOffTime?: Date;
	UserCreatedAt: Date | null;
	OrderRequested?: Date;
	OrderChats?: OrderChatDto[];
	DropoffOrderTimes?: Date[];
	PickupSurgeAmount?: number;
	WaitingFeeAmount?: number;
	PickupAddress?: any;
	DropoffOrderPoints?: PointWithAddress[];
	CanceledAt?: Date;
	SessionTime: string;
	IsPriority?: boolean;
	UserFirstName: string;
	UserLastName: string;
	UserSignUpDaysPassed: number;
	UserPhoneMask: string;
	LoginProvider: string;
	BookingsCount: number;
	CompletedCount: number;
	CompletedPercent: number;
	TotalSpend: number;
	XpressPaymentTransaction?: XpressPaymentTransaction;
	RemainingTimeSeconds?: number;
	IsCustomerAcceptWaitingTime: boolean;
	PackagePhotoImageUrl?: string;
	PickupPhotoImageUrl: string;
	PickupSignatureImageUrl: string;
	DropPhotoImageUrl: string;
	DropSignatureImageUrl: string;
	ClientLocationType: number;
	PriorityBonus?: number;
	DropOffOptions?: any;
	DeliverySenderName?: string;
	DeliverySenderPhone?: string;
	PackageImgUrlPreview?: string;
	PackageImgUrlSmall?: string;
	IsBackToBack: boolean;
	IsFraud: boolean;
	FraudScore: number;
	RiderBirthDate: Date | null;
	AdminActionTimestamp?: Date;
	AdminActionedBy: string;
}

export interface Point {
	Lat: number;
	Long: number;
}

export interface PointWithAddress extends Point {
	Address: string;
	BuildingName: string;
	Name: string;
}

export interface OrderSummaryItem {
	Id: number;
	Name: string;
	Quantity: number;
	Price: number;
}

export interface OrderChatDto {
	CreatedAt: Date;
	MessageTypeId: ChatMessageType;
	Message: string;
	RiderFullName: string;
	CustomerFullName: string;
}

export interface XpressPaymentTransaction {
	Id?: number;
	CreatedAt?: Date;
	TransactionTypeId?: TransactionType;
	TransactionTypeText: string;
	PaymentMethodId?: XpressDeliveryPaymentMethod;
	PaymentMethodText: string;
	TransactionAmount?: number;
	PartnerTXID: string;
	Status: string;
	CardType: string;
	OperationTypeId?: XpressUserWalletOperationType;
	OperationTypeText: string;
}

export enum BookingTabMenuEnum {
	None = 0,
	Bookings = 1,
	ScanAndRide = 2,
	Scheduled = 3,
	Twenty = 4,
	OneHundred = 5,
	FiveHundred = 6
}
